<template>
  <div class="examSystem">
    <common-breadcrumb2024 />
    <div class="conWrap"
         v-show="showStatus">
      <div class="th clearfix">
        <div class="intro">
          <h3>{{ categoryTitle }}</h3>
          <table class="tips">
            <tr>
              <th>逼<i style="display:inline-block;width:14px;"></i>真：</th>
              <td>模拟计算机考试，感受真实的考试场景</td>
            </tr>
            <tr>
              <th>含金量：</th>
              <td>紧扣教学大纲和考试要求，全面覆盖各类知识点</td>
            </tr>
            <tr>
              <th>效<i style="display:inline-block;width:14px;"></i>果：</th>
              <td>海量题库，随机抽题组卷，评估自己的水平</td>
            </tr>
          </table>
          <div class="action-mod">
            <a href="javascript:void(0)" class="startExam" @click="startExam">开始考试</a>
            <a href="javascript:void(0)" class="buy-vip-btn" @click="gotoUnlock" v-if="vipInfo.vipProductFlag&&!vipInfo.userVipFlag&&flag=='huiyuan'">
              <i class="icon-vip-logo"></i>
              <span>购买题库会员</span>
              <div class="top-tips">解锁权益{{ vipInfo.vipRightsNum }}+</div>
            </a>
          </div>
        </div>
        <div class="blessings">
          <h3>友情提示</h3>
          <h4>今天是<strong v-html="this.currentData"></strong></h4>
          <p v-html="blessingsConvert"></p>
        </div>
      </div>
      <div class="clearfix">
        <div class="preexam">
          <iframe src="//www.chinaacc.com/OtherItem/qzSimIframe/zhongjizhicheng.shtml" frameborder="0" width="470px" height="170" marginwidth="0" marginheight="0" hspace="0" vspace="0" scrolling="no"></iframe>
        </div>
        <div class="questions">
          <div class="tit"><h4>常见问题</h4></div>
          <ul>
            <li><a href="javascript:void(0)"
                 @click="custormAnchor('F1')">机考系统常见拼音输入法</a></li>
            <li><a href="javascript:void(0)"
                 @click="custormAnchor('F2')">模拟考试系统可以自动判卷吗？</a></li>
            <li><a href="javascript:void(0)"
                 @click="custormAnchor('F2')">错题可以重做吗？</a></li>
            <li><a href="javascript:void(0)"
                 @click="custormAnchor('F2')">模拟考试和真实考试一样吗？</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="questions-con"
         v-show="!showStatus">
      <div class="mrtext">
        <h2>常见问题</h2>
        <div class="mainrtext">
          <div id="F1">
            <p><strong>机考系统中常见拼音输入法：</strong></p>
            <p>根据国家机考系统要求，机考系统中会有6种输入法供考生选择，即微软拼音输入法、谷歌拼音输入法、搜狗拼音输入法、王码五笔型输入法、极品五笔输入法、万能五笔输入法。不提供手写板等辅助输入设备与软件。</p>
            <p>网校建议您使用机考系统要求的输入法进行打字练习，以提高机考时的答题速度。</p>
            <p>输入法下载地址：</p>
            <p>搜狗拼音输入法：http://pinyin.sogou.com/</p>
            <p>极品五笔输入法：http://www.jpwb.net/</p>
            <p>万能五笔输入法：http://www.wnwb.com/</p>
            <p>微软拼音输入法： windows 系统自带</p>
            <p>王码五笔型输入法： windows 系统自带</p>
          </div>
          <p><strong>功能说明： </strong></p>
          <p><strong>模拟考试系统：</strong>模拟真实考试环境，考生的专业无纸化考试模拟平台。严格按照考试要求编写试题，题目紧扣考试大纲，知识点覆盖全面。时间提醒、按时交卷、自动评分、答案解析、错题收藏等人性化系统提示让学员提前进入考试状态。
          </p>
          <p><strong>考试记录：</strong>统计试题正确率，分析试卷题目，让学员了解自己复习的薄弱点，并设有重做试卷、重做错题等功能。</p>
          <p><strong>错题记录：</strong>对于模拟试卷中做错的题目，学员可有针对性地再次选做，巩固薄弱知识点。</p>
          <p><strong>答案解析：</strong>按考试要求智能组卷，自动判卷，答案解析凝结了网校名师对考题的深刻理解，能够帮助考生高屋建瓴地理解历年考题的命题思路和解题方法。</p>
          <div id="F2">
            <p><strong>常见问题： </strong></p>
            <p><strong><a href="javascript:void(0)"
                   name="mkcy">1.模拟考试系统可以重复使用吗？</a></strong></p>
            <p>可以，系统会就考试中每个知识点汇总出题，针对性强，我们将提供题库升级服务。 </p>
            <p><strong><a href="javascript:void(0)"
                   name="mkpj">2.模拟考试系统可以自动判卷吗？</a></strong></p>
            <p>无纸化考试模拟结束后，系统会自动批阅试卷并显示得分，您可以查看考试成绩，系统还会统计出您做题的正确率。</p>
            <p><strong><a href="javascript:void(0)"
                   name="ctcz">3.错题可以重做吗？</a></strong></p>
            <p>系统会记录下每次答题情况，您可以将错题调出重做，反复练习，加深印象。 </p>
            <p><strong><a href="javascript:void(0)"
                   name="mkzs">4.无纸化考试模拟和真实考试一样吗？</a></strong></p>
            <p>无纸化模拟考试系统是根据往年考试情况进行的模拟仿真考试，仅供考生模拟使用，非真实考试。 </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { CommonBreadcrumb2024 } from '@components/common'
import mixinFilter from '@/mixins'
import mixinCl from '@/mixins/checkLogged'
import { title } from '@base/settings'
import { OpenActivateVipDialog } from '@/components/dialog/dialog'
import {getIconsApi} from '@api'
import { isEmptyObject } from "@/utils"
export default {
  name: 'ExamSystem',
  components: {
    CommonBreadcrumb2024,
  },
  props: {
    showStatus: {
      type: Boolean,
      default: false,
    },
    preExamUrl: {
      type: String,
      default: '//www.chinaacc.com/mnxt/zk.htm',
    },
    faqs: {
      type: Array,
      default: () => [],
    },
    blessings: {
      type: Object,
      default: () => ({
        content:
          '今天是#date# <br />考试时间：5月12日至20日。<br />正保会计网校祝您梦想成真！',
      }),
    },
  },
  mixins: [mixinFilter, mixinCl],
  data() {
    return {
      categoryTitle: '',
      flag: '',
    }
  },
  computed: {
    blessingsConvert() {
      return this.blessings.content
    },
    ...mapGetters([
      'siteData',
      'vipInfo'
    ]),
  },
  mounted() {
    this.categoryTitle = title
    const { flag } = this.$route.params
    this.flag = flag === 'paidExam' ? '' : flag
    this.init()
  },
  methods: {
      async init(){
     if (isEmptyObject(this.siteData)) {
          const { flag } = this.$route.params
          const { siteCourseID } = this.$route.query
          let params = {
            flag: flag,
            majorID: this.$categoryInfo.majorID,
            siteCourseID: Number(siteCourseID)
          }
          await this.$store.dispatch('getCurrentSiteInfo', params)
          .then(res => {
            this.courseInfo = res.currentCourse
          })
          .catch(err => {
            this.$message.error(err.msg)
          })
        } else {
              this.courseInfo = this.siteData.currentCourse
              this.$store.dispatch('getTikuUserVipFlag', {
                courseEduID:  this.courseInfo.courseEduID,
                eduSubjectID:  this.courseInfo.eduSubjectID,
              })
            }
    },
    startExam() {
      const { courseID, siteCourseID } = this.$route.query
      const { flag } = this.$route.params
      this.$router.push({
        path: `/${flag}/realMockExam`,
        query: {
          siteCourseID: siteCourseID,
          courseID: courseID,
        },
      })
    },
    // 锚点跳转
    custormAnchor(anchorName) {
      this.$emit('update:showStatus', false)
      let anchorElement = document.getElementById(anchorName)
      let fatherElement = document.querySelector('.mrtext')
      this.$nextTick(() => {
        fatherElement.scrollTop = anchorElement.offsetTop - 40
      })
    },
      gotoUnlock() {
      window.CDEL.setLoad()
      const params = {
        type: 13,
        courseEduId: this.siteData.currentCourse.courseEduID,
        eduSubjectID: this.siteData.currentCourse.eduSubjectID,
        newType: 5
      }
      getIconsApi(params)
        .then((resp) => {
          if (resp.success && resp.result.iconsLibraryList) {
            const { courseID } = this.$route.query
            OpenActivateVipDialog({
              list: resp.result.iconsLibraryList,
              url: resp.result.pcUrl,
              link: `//www.chinaacc.com/tiku/member/${
                this.$categoryInfo.majorID
              }-${courseID}`
            })
          }
        })
        .catch((e) => {
          console.error('获取题库会员权益失败：', e)
        })
        .finally(() => {
          window.CDEL.setLoad(true)
        })
      }
  },
}
</script>
<style lang="scss" scoped>
  .examSystem {
    float:right;
    width:950px;
  }
  .conWrap {
    background: #fff;
    padding:30px 0 13px 30px;

    .th {
      padding-bottom: 30px;
    }

    .intro {
      float: left;
      width:608px;
      height:270px;
      padding:0 0 0 24px;
      background: url("~@/assets/images/mockExam/examSystem-bg01.jpg") no-repeat;

      h3 {
        color: #222;
        font-weight: bold;
        font-size: 22px;
        line-height: 32px;
        padding-top:26px;
      }

      .tips {
        margin-top:20px;
        padding: 0;

        tr {
          height: 29px;
          line-height: 29px;
          color: #666;
          font-size: 14px;
          text-align: left;

          th {
            font-weight:bold;
            text-align: left;
          }

          span {
            color: #04446b;
            font-weight: 700;
          }
        }
      }

      .startExam {
        width: 180px;
        height: 48px;
        line-height:47px;
        text-align:center;
        font-size:18px;
        font-weight:bold;
        color:#fff;
        text-shadow: 0 1px 4px #FD7400;
        background: linear-gradient( 127deg, #FFB65A 0%, #FF8941 100%);
        background: -webkit-linear-gradient( 127deg, #FFB65A 0%, #FF8941 100%);
        display: block;
        border-radius:25px;
        margin: 20px 0 0 0;
      }
    }

    .questions {
      float: right;
      width: 258px;
      font-size: 12px;
      color: #01408e;
      margin:0 20px 0 0;
      .tit{
        height:40px;
        border-bottom:1px solid #F1F1F1;
        h4{
          float:left;
          line-height:38px;
          font-size:18px;
          color:#07BDC7;
          border-bottom:2px solid #07BDC7;
        }
      }

      .img {
        float: left;
      }

      ul {
        padding: 22px 0 0;
        li {
          line-height: 30px;
          font-size:14px;
          color:#333;
          padding-left:15px;
          position:relative;
          &:before{
            content:"";
            width:5px;
            height:5px;
            border-radius:50%;
            background:#C1EEF1;
            position:absolute;
            left:0;
            top:13px;
          }
        }
      }

    }

    .preexam {
      float: left;
      width: 608px;
      overflow: hidden;
      padding-left:9px;
      .tit{
        width:470px;
        height:40px;
        border-bottom:1px solid #F1F1F1;
        h4{
          float:left;
          line-height:38px;
          font-size:18px;
          color:#07BDC7;
          border-bottom:2px solid #07BDC7;
        }
      }

      .list{
        padding:7px 0 0 8px;
        .btn{
          display:block;
          float:left;
          width:178px;
          height:36px;
          line-height:36px;
          padding-left:46px;
          margin-top:23px;
          &.ico01{
            background: url("~@/assets/images/mockExam/preexam-ico01.png") no-repeat left center;
          }
          &.ico02{
            background: url("~@/assets/images/mockExam/preexam-ico02.png") no-repeat left center;
          }
          &.ico03{
            background: url("~@/assets/images/mockExam/preexam-ico03.png") no-repeat left center;
          }
          &.ico04{
            background: url("~@/assets/images/mockExam/preexam-ico04.png") no-repeat left center;
          }
          &.ico05{
            background: url("~@/assets/images/mockExam/preexam-ico05.png") no-repeat left center;
          }
          &.ico06{
            background: url("~@/assets/images/mockExam/preexam-ico06.png") no-repeat left center;
          }
        }
      }

    }

  }
  .questions-con {
    background: #fff;
    .mrtext {
      padding: 30px 30px;
      overflow: auto;
      font-size: 14px;
      height:545px;
      h2{
        font-size:20px;
        color:#07BDC7;
        line-height:32px;
        position:relative;
        &:before{
          content:"";
          width:4px;
          height:20px;
          background:#07BDC7;
          position:absolute;
          left:-30px;
          top:7px;
        }
      }
      p {
        margin-top: 14px;
        color:#333;
        line-height:22px;
      }
    }
  }
  .action-mod {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .buy-vip-btn {
    margin: 20px 0 0 20px;
    width: 160px;
    height: 48px;
    background: url(~@/assets/images/vip/bg_btn.png) no-repeat center;
    background-size: 100% 100%;
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    i.icon-vip-logo {
      display: inline-block;
      width: 18px;
      height: 15px;
      background: url(~@/assets/images/vip/icon_vip.png) no-repeat center;
      background-size: 100% 100%;
    }

    span {
      margin-left: 5px;
      font-weight: bold;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 21px;
    }

    .top-tips {
      padding: 0 10px;
      height: 20px;
      background: linear-gradient(133deg, #ff7400 0%, #ff4500 100%);
      // border-radius: 13px;
      border-radius: 100px;
      font-weight: 600;
      font-size: 12px;
      color: #ffffff;
      line-height: 20px;
      position: absolute;
      top: -13px;
      right: -7px;
    }
  }
</style>
<style lang="scss">
  .blessings {
    float: right;
    width:247px;
    height:212px;
    margin-right:25px;
    margin-top:18px;
    background: url("~@/assets/images/mockExam/examSystem-bg02.jpg") no-repeat;
    line-height: 24px;
    color: #666;
    font-size: 13px;
    text-align:center;
    h3{
      line-height:40px;
      color:#FD7400;
      font-weight:bold;
    }
    h4{
      line-height:30px;
      font-size:14px;
      padding-top:16px;
      span{
        color:#FD7400;
      }
    }
    p{
      display:block;
      margin:3px 0 0 20px;
      width:200px;
      font-size:14px;
      text-align:left;
      background: #FEFBF7;
      line-height:24px;
      padding:7px 0 15px 10px;
      border: 1px solid #FFECDB;
    }
  }
</style>
